module.exports = __webpack_public_path__ + "img/bm.78d64209.svg";